import React from "react"
import {twMerge} from "tailwind-merge"

import enrichmentFailed from "../assets/enrichment_failed.svg"

type TSize = "xs" | "sm" | "md" | "xl"

type TProps = {
  size?: TSize
  fullSpace?: boolean
  containerClassName?: string
}

const sizePropTable = {
  xs: {container: "w-4 h-4"},
  sm: {container: "w-6 h-6"},
  md: {container: "w-8 h-8"},
  xl: {container: "w-16 h-16"},
} as const satisfies {[sizeProp in TSize]: {container: string}}

export const EnrichmentFailed: React.FC<TProps> = ({size = "md", fullSpace = true, containerClassName}) => {
  return (
    <div
      className={twMerge(["flex", fullSpace && "h-full w-full grow items-center justify-center", containerClassName])}
    >
      <div className={twMerge(["relative inline-block", sizePropTable[size].container])}>
        <img src={enrichmentFailed} className={"h-full w-full"} alt={"EnrichmentFailed"} />
      </div>
    </div>
  )
}
